<template>
  <div
    class="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6"
  >
    <h1 class="text-2xl font-bold mb-6 text-gray-800">Broker QR Code</h1>
    <div v-if="qrCodeDataUrl" class="flex flex-col items-center space-y-4">
      <img
        :src="qrCodeDataUrl"
        alt="Broker QR Code"
        class="w-64 h-64 rounded-xl shadow-md border border-gray-200"
      />
      <button
        @click="copyLink"
        class="bg-ds-button-color text-white font-semibold px-5 py-2 rounded-xl shadow-md transition hover:scale-105 active:scale-95"
      >
        Share My Code
      </button>

      <p
        v-if="copySuccess"
        class="text-green-600 text-sm font-medium transition-opacity duration-300"
      >
        Link copied to clipboard!
      </p>
    </div>

    <div v-else class="text-gray-500 text-sm mt-6">Generating QR Code...</div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import QRCode from "qrcode";

export default {
  setup() {
    const store = useStore();
    const brokerQR = computed(() => store.state.adminLogDetails?.brokerLink);
    const qrCodeDataUrl = ref("");
    const copySuccess = ref(false);
    onMounted(async () => {
      if (brokerQR.value) {
        try {
          qrCodeDataUrl.value = await QRCode.toDataURL(brokerQR.value, {
            width: 256,
            margin: 2,
            color: { dark: "#000000", light: "#ffffff" },
          });
        } catch (err) {
          console.error("QR generation failed:", err);
        }
      }
    });
    const copyLink = async () => {
      if (!brokerQR.value) return;
      try {
        await navigator.clipboard.writeText(brokerQR.value);
        copySuccess.value = true;
        setTimeout(() => (copySuccess.value = false), 2000);
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    };

    return {
      brokerQR,
      qrCodeDataUrl,
      copySuccess,
      copyLink,
    };
  },
};
</script>
